import { render, staticRenderFns } from "./InformationLayout.vue?vue&type=template&id=7b72ec13"
import script from "./InformationLayout.vue?vue&type=script&lang=js"
export * from "./InformationLayout.vue?vue&type=script&lang=js"
import style0 from "./InformationLayout.vue?vue&type=style&index=0&id=7b72ec13&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports